import styled from "styled-components";

const LoginWrapper = styled.div`
  width: 90%;
  height: calc(100% - 50px);
  margin: auto;
`;

const LoginSliderWrapper = styled.div`
  width: 100%;
  margin-top: 50px;
`;

const SliderContentsWrapper = styled.div`
  height: 350px;
  position: relative;
  text-align: center;
`;

const BtnWrapper = styled.div`
  width: 90%;
  height: 15vh;
  position: absolute;
  bottom : 10%;
  text-align: center;
  margin: auto;
`;

const LoginComment = styled.img`
  width: 60%;
`;

const LoginBtn = styled.div`
  width: 100%;
  height: 50px;
  position: absolute;
  text-align : center;
  line-height: 50px;
  text-align: center;
  color: ${(props) => props.color || "black"};
  background-color: ${(props) => props.bgcolor || "#F9EB00"};
`;

const LoginImg = styled.img`
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%, 0%);
`;

export { 
    LoginWrapper, 
    LoginBtn, 
    LoginSliderWrapper, 
    SliderContentsWrapper, 
    LoginImg,
    BtnWrapper,
    LoginComment,
};